import React, { Component, createRef } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import InfiniteCalendar from "react-infinite-calendar";
import moment from "moment";
import {
  slotActions,
  appointmentActions,
  counsellorActions,
} from "../../store/actions";
import Footer from "../../components/Footer/footer";
import "../../static/css/slot.css";
import "react-infinite-calendar/styles.css";
import { Spring } from "react-spring";
import Swal from "sweetalert2";
import { paypalClientId } from "../../config";
import Loading from "../../components/Loading/Loading";
import PaypalModal from "../../components/PaypalModal/PaypalModal";
import ForeeModal from "../../components/ForeeModal/ForeeModal";
import RequestSession from "../../components/RequestASession";
import { constants } from "../../Constants";
import { history } from "../../helpers/history";
import {
  cryptString,
  decryptString,
  getSessionsRemaining,
} from "../../helpers/utils";

class DatePicker extends Component {
  constructor(props) {
    super(props);
    this.createAppointment = this.createAppointment.bind(this);
    this.cancelAppointment = this.cancelAppointment.bind(this);
    this.arrangeSession = this.arrangeSession.bind(this);
    this.enableBeforeUnload = this.enableBeforeUnload.bind(this);
    this.disableBeforeUnload = this.disableBeforeUnload.bind(this);
    this.getDatesArray = this.getDatesArray.bind(this);
    this.showNextAppointment = this.showNextAppointment.bind(this);
    this.state = {
      selectedDate: new Date(),
      filtered_slots: [],
      slots: "",
      all_slots: [],
      date_array: "",
      slot_id: "",
      selected_date_time: "",
      is_selected: null,
      counsellorFee: 1,
      isLoading: false,
      formfilling: false,
      paypalModalVisible: false,
      paypalScriptLoaded: false,
      showRequestModal: false,
      dateTimes: [{ date: new Date(), time: "00:00:00" }],
      countryName: null,
      foreeModalVisible: false,
      cryptedString: null,
      subDomain: '',
      counsellorDetails:null,
    };
  }

  enableBeforeUnload() {
    window.onbeforeunload = function (e) {
      return "";
    };
  }

  disableBeforeUnload() {
    window.onbeforeunload = null;
  }

  componentWillMount() {
    const { user } = this.props;
    this.loadPaypalScript();
    const counsellorId =  window.location.pathname.split("/")[2];
    this.props.getCounsellorDetails(counsellorId);
    this.props.fetchTimeSlots(counsellorId);
    this.formatSlotsByDate(this.state.selectedDate);
  }

  // Get country name
  getCountryDetails = async () => {
    this.setState({ countryName: await this.props.user && this.props.user.subsidiary && this.props.user.subsidiary.toLowerCase() });
  };

  componentDidMount() {
    this.props.getSessionCaps()
    if (!this.state.countryName) this.getCountryDetails();
    const {user} = this.props;
    if(user === undefined){
      history.push('/')
    }
  }

  loadPaypalScript = () => {
    const script = document.createElement("script");
    script.addEventListener("load", () => {
      // this.loadPaypalButton();
      // this.setState({
      //   showPaypalModal:true
      // })
    });
    script.src = `https://www.paypal.com/sdk/js?client-id=${paypalClientId}&currency=USD`;
    document.body.appendChild(script);
  };
  componentWillUnmount() {
    this.props.resetSlots();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.all_slots !== undefined) {
      this.setState({ all_slots: nextProps.all_slots });
      this.showNextAppointment();
    }
    if (nextProps.counsellorDetails !== undefined) {
      this.setState({ counsellorDetails: nextProps.counsellorDetails });
    }
    if (nextProps.whitelabel && nextProps.whitelabel.length > 0) {
      const subDomain = nextProps.whitelabel[0].sub_domain.toLowerCase();
      this.setState({
        subDomain: subDomain
      })
    }
  }

  callAppointmentApiCall = (response, phoneNumber, provider) => {
    const isPaypal = provider === "paypal";
    const { user } = this.props;
    const counsellorId =
      user && user.counsellor_id
        ? user.counsellor_id
        : this.props.match.params.id;
    const subDomain =
      this.props.whitelabel &&
        this.props.whitelabel.length > 0 &&
        this.props.whitelabel[0].sub_domain
        ? this.props.whitelabel[0].sub_domain
        : "";

    const status = isPaypal
      ? response && response.status && response.status === "COMPLETED"
        ? "success"
        : "failure"
      : response.status && response.bill_status === "paid"
        ? "success"
        : "failure";
    const amount = isPaypal
      ? response &&
        response.purchase_units &&
        response.purchase_units.length > 0 &&
        response.purchase_units[0].payments &&
        response.purchase_units[0].payments.captures &&
        response.purchase_units[0].payments.captures.length > 0 &&
        response.purchase_units[0].payments.captures[0].amount
        ? response.purchase_units[0].payments.captures[0].amount
        : {
          currency_code: "USD",
          value: this.props.counsellorDetails.price_usd,
        }
      : response &&
      response.paid_amount && {
        currency_code: "PKR",
        value: String(this.props.counsellorDetails.price_pkr),
      };

    const payment_id = isPaypal
      ? status === "success"
        ? response.id
        : "N/A"
      : response && response.transaction_ref_id;

    const error_msg = isPaypal
      ? response.status && response.status === "COMPLETED"
        ? ""
        : response.details && response.details[0]
          ? response.details[0].issue
          : "INSTRUMENT_DECLINED"
      : response.status && response.bill_status === "paid"
        ? ""
        : response.message;

    let appointmentDetails = {
      slot_id: this.state.slot_id,
      user_id: JSON.parse(localStorage.getItem("user")).user_id,
      phoneNumber: phoneNumber,
      sub_domain: subDomain,
      payment: status,
      amount: amount,
      payment_details: {
        customer_reference_id: this.state.cryptedString,
        payment_id: payment_id,
        paypal_payment_status: isPaypal ? true : false,
        payment_time: new Date(
          new Date().setHours(
            new Date().getHours() - new Date().getTimezoneOffset() / 60
          )
        ).toISOString(),
        error_msg: error_msg,
      },
    };
    this.props.createAppointment(appointmentDetails, counsellorId);
    this.setIsLoading(false);
  };

  showPaypalModal = () => {
    this.setState((prevState) => ({
      paypalModalVisible: !prevState.paypalModalVisible,
    }));
  };

  showForeeModal = () => {
    this.setState((prevState) => ({
      foreeModalVisible: !prevState.foreeModalVisible,
    }));
  };

  setIsLoading = (loading) => {
    this.setState({
      isLoading: loading,
    });
  };
  addSchedule = (e) => {
    let { dateTimes } = this.state;
    if (dateTimes.length < 3) {
      dateTimes.push({ date: new Date(), time: "00:00:00" });
      this.setState({ dateTimes });
    }
  };

  errorPopup = (text) => {
    Swal.fire({
      icon: "error",
      title: "Saaya Health",
      text: text,
      confirmButtonColor: "#36A692",
    });
  };

  createAppointment() {
    const { user } = this.props;
    const counsellorId = this.props.match.params.id
   if (
      this.state.slot_id === null ||
      this.state.slot_id === undefined ||
      this.state.slot_id === ""
    ) {
      alert(constants.INVALID_TIME_SLOT_MSG);
    } else {
      if (this.props.whitelabel[0].payment_required) {
        this.setState({
          cryptedString: cryptString(
            user.user_email.split("@")[0] + "-" + Date.now()
          ),
        });
        this.state.countryName === "pakistan"
          ? this.props.counsellorDetails.price_pkr === 0
            ? this.errorPopup("Counsellor price is not available.")
            : this.showForeeModal()
          : this.props.counsellorDetails.price_usd === 0
            ? this.errorPopup("Counsellor price is not available.")
            : this.showPaypalModal();
      } else {
        Swal.fire({
          title: constants.DELETE_CONFORM_HEADER_TXT,
          text: "You sure you want to create this appointment!",
          type: "question",
          reverseButtons: true,
          showCancelButton: true,
          confirmButtonColor: "#36A692",
          cancelButtonColor: "#d33",
          cancelButtonText: "No",
          confirmButtonText: "Yes",
          onOpen: function () {
            Swal.getPopup()
              .querySelector(".swal2-confirm")
              .setAttribute("id", "btnConfirmCreateAppointment");
            Swal.getPopup()
              .querySelector(".swal2-cancel")
              .setAttribute("id", "btnCancelCreateAppointment");
          },
        }).then((result) => {
          if (result.value) {
            /* whitelabel subdomain details would appended here */
            const subDomain =
              this.props.whitelabel &&
                this.props.whitelabel.length > 0 &&
                this.props.whitelabel[0].sub_domain
                ? this.props.whitelabel[0].sub_domain
                : "";
            let appointmentDetails = {
              slot_id: this.state.slot_id,
              user_id: JSON.parse(localStorage.getItem("user")).user_id,
              sub_domain: subDomain,
              payment: "notrequired",
            };
            this.props.createAppointment(appointmentDetails, counsellorId);
          } else {
          }
        });
      }
    }
  }

  formatSlotsByDate = (date) => {
    let parsedDate = this.parseDate(date);
    let filtered_slots = this.state.all_slots.filter((item) => {
      if (item.date_time) {
        return (item.date_time = moment(item.date_time).format());
      }
    });

    filtered_slots = filtered_slots.filter(
      (filtered_slots, index, self) =>
        index ===
        self.findIndex((t) => t.date_time === filtered_slots.date_time)
    );

    filtered_slots = filtered_slots.filter((slot) => {
      return slot.date_time.toString().startsWith(parsedDate);
    });

    filtered_slots = filtered_slots.filter((slot) => {
      if (slot.selected_by == null) {
        return slot;
      }
    });
    const selected = Array.isArray(filtered_slots) && filtered_slots.find(item => item.is_selected);
    this.setState({
      filtered_slots: filtered_slots,
      selected_date_time: selected && selected.date_time || "",
      slot_id: selected ? selected.id : ""
    });
  };

  getDatesArray() {
    var dateArray = [];
    var datesFormatArray = [];
    var currentDate = moment();
    let all_slot_dates, date_array, first_slot;
    var stopDate = moment().add(30, "days");
    while (currentDate <= stopDate) {
      dateArray.push(moment(currentDate).format("YYYY-MM-DD"));
      currentDate = moment(currentDate).add(1, "days");
    }
    if (this.state.all_slots.length > 0) {
      all_slot_dates = this.state.all_slots
        .filter((slot) => {
          slot.date_time = moment(slot.date_time).format()
          if (slot.selected_by == null) {
            return true;
          }
        })
        .sort(function (a, b) {
          a = new Date(a.date_time);
          b = new Date(b.date_time);
          return a < b ? -1 : a > b ? 1 : 0;
        });
      date_array = all_slot_dates.map((s) => s.date_time.slice(0, 10));

      first_slot = all_slot_dates[0] && all_slot_dates[0].date_time;
      dateArray = dateArray.filter(function (item) {
        return !date_array.includes(item);
      });
      dateArray.map((date) => {
        // datesFormatArray.push(new Date(date));
        datesFormatArray.push(
          moment(new Date(date)).utc().format("ddd DD MMM YYYY hh:mm:ss A")
        );
      });
      return datesFormatArray;
    } else {
      dateArray.map((date) => {
        datesFormatArray.push(
          moment(new Date(date)).utc().format("ddd DD MMM YYYY hh:mm:ss A")
        );
        // datesFormatArray.push(new Date(date));
      });
      return datesFormatArray;
    }
  }

  formatDate = (date) => {
    if (date < 10 && date !== 0) {
      return "0" + date;
    } else if (date > 10) {
      return date;
    } else {
      return date + "";
    }
  };

  parseDate = (date) => {
    let parsed_date =
      date.getFullYear() +
      "-" +
      this.formatDate(date.getMonth() + 1) +
      "-" +
      this.formatDate(date.getDate());
    return parsed_date;
  };

  toggleStyles(item, i) {
    this.setState({ slot_id: item.id });
    let selected_slot = this.state.filtered_slots.filter((slot) => {
      if (item.id === slot.id) {
        return slot;
      } else {
        return (slot.is_selected = false);
      }
    });
    selected_slot[0].is_selected = !this.state.is_selected;
    this.setState({ selected_slot });
    this.setState({ selected_date_time: item.date_time });
  }

  cancelAppointment() {
    Swal.fire({
      title: constants.DELETE_CONFORM_HEADER_TXT,
      text: constants.LEAVE_SCREEN_MSG,
      type: "question",
      reverseButtons: true,
      showCancelButton: true,
      confirmButtonColor: "#36A692",
      cancelButtonColor: "#d33",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
      onOpen: function () {
        Swal.getPopup()
          .querySelector(".swal2-confirm")
          .setAttribute("id", "btnConfirmLeave");
        Swal.getPopup()
          .querySelector(".swal2-cancel")
          .setAttribute("id", "btnCancelLeave");
      },
    }).then((result) => {
      if (result.value) {
        this.setState({
          filtered_slots: [{ is_selected: false }],
        });
        this.setState({ selected_date_time: "" });
        this.props.history.goBack();
      } else {
      }
    });
  }

  arrangeSession() {
    this.props.arrangeSession(this.props.counsellorDetails.counsellor_id,this.props.whitelabel[0].id,this.props.whitelabel && this.props.whitelabel[0].producer_role)
  }

  isSlotSelected(slot) {
    if (slot.is_selected) {
      return {
        backgroundColor: "#3257a8",
        pointerEvents: "none",
        color: "white",
        fontWeight: "400",
        cursor: "none",
        padding: "10px",
      };
    } else if (!slot.is_selected) {
      return {
        padding: "10px",
        pointerEvents: "all",
        cursor: "pointer",
      };
    }
  }

  getDate = (selectedDate) => {
    this.setState({ formfilling: true });
    this.formatSlotsByDate(selectedDate, this.state.slots);
    this.enableBeforeUnload();
    this.setState({ selectedDate });
  };

  showNextAppointment() {
    let first_slot;
    let all_slot_dates = [];
    if (this.state.all_slots.length > 0) {
      all_slot_dates = this.state.all_slots.sort(function (a, b) {
        a = new Date(a.date_time);
        b = new Date(b.date_time);
        return a < b ? -1 : a > b ? 1 : 0;
      }).filter((element)=>{
        if(element.selected_by == null){
          return true
        }
      })
      if(all_slot_dates.length){
        first_slot = all_slot_dates[0].date_time;
      }
    }
    if (
      first_slot !== undefined &&
      this.state.filtered_slots.length == 0 &&
      !this.state.formfilling
    ) {
      let formattedDate = new Date(first_slot);
      this.getDate(formattedDate);
    }
    return first_slot;
  }

  toggleRequestModalB2C = (status) => {
    this.setState({
      showRequestModal: status,
    });
    history.replace('/home');
  }

  toggleRequestModal = (status) => {
    const { user } = this.props;
    const counsellorId =
      user && user.counsellor_id
        ? user.counsellor_id
        : this.props.match.params.id;
    this.setState({
      showRequestModal: status,
      dateTimes: [{ date: new Date(), time: "00:00:00" }],
    });
    if(this.state.subDomain === 'online'){
      this.props.requestSlotB2C(counsellorId)
    }
  };

  onTimeChange = (e, item) => {
    const idx = item;
    const { dateTimes } = this.state;
    dateTimes[idx].time = e.target.value;
    this.setState({ dateTimes });
  };
  onDateChange = (date, modifiers, e) => {
    const controlId = e.props.id;
    const idx = controlId[controlId.length - 1];
    const { dateTimes } = this.state;
    dateTimes[idx].date = date;
    this.setState({ dateTimes });
  };

  submitSessionRequest = () => {
    const { user } = this.props;
    const counsellorId =this.props.match.params.id;
    const { dateTimes } = this.state;
    let dates = [];
    if (dateTimes && dateTimes.length) {
      dateTimes.forEach((d) => {
        const i = `${moment(d.date).format("YYYY-MM-DD")} ${d.time}`;
        dates.push(moment(i, "YYYY-MM-DD hh:mm:ss").utc().format());
      });
      this.props.requestSlot(dates.join(","), counsellorId);
    }
  };

  render() {
    const { user } = this.props;
    const filtered_slots = this.state.filtered_slots;
    let today = new Date();
    var lastWeek = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() + 21
    );
    return (
      <div className={ this.state.showRequestModal ? "ContainerFix-modal-open" : "ContainerFix"}>
        <div className="container containerFlex">
          <div className="text-center welcome-text">
            {constants.PLZ_CHOOSE_SESSION_TXT}
            <br />
            {this.state.counsellorDetails && this.state.counsellorDetails.counsellor_name &&
              "with " + this.state.counsellorDetails.counsellor_name}
          </div>
          <br />

          <div className="row mt-3">
            <div className="appointment-card col-xs-12 col-sm-12 col-md-12 overflow-auto col-lg-6  text-center">
              <div className="calendar">
                <InfiniteCalendar
                  displayOptions={{
                    layout: "portrait",
                    showOverlay: false,
                    shouldHeaderAnimate: false,
                  }}
                  onSelect={this.getDate}
                  theme={{
                    accentColor: "#448AFF",
                    floatingNav: {
                      background: "#4ca7db",
                      chevron: "#FFA726",
                      color: "#FFF",
                    },
                    headerColor: "#3257a8",
                    selectionColor: "#3257a8",
                    textColor: {
                      active: "#FFF",
                      default: "#333",
                    },
                    todayColor: "#FFA726",
                    weekdayColor: "#3ca592",
                  }}
                  format={(value, name) => value || null}
                  disabledDates={this.getDatesArray()}
                  selected={this.showNextAppointment()}
                  width={300}
                  height={300}
                  max={lastWeek}
                  min={today}
                  minDate={today}
                  maxDate={lastWeek}
                />
              </div>
            </div>
            <div className="appointment-card col-xs-9 col-sm-12 col-md-12 col-lg-5 overflow-hidden">
              <div>
                <div className="time_slots">
                  <div className="time_slot_heading">
                    {constants.TIME_SLOTS_TXT}
                  </div>
                  <hr />
                  <div className="time_slots_group">
                    {this.state.filtered_slots.length > 0 && (
                      this.state.filtered_slots.map((item, i) => {
                        return (
                          <div className="ind-time-slot" key={i}>
                            <div
                              style={this.isSlotSelected(item)}
                              onClick={() => this.toggleStyles(item, i)}
                              id={
                                "divTimeSlot" +
                                moment().day() +
                                moment(item.date_time).format("h")
                              }
                            >
                              {moment(item.date_time).format("h:mm A")}
                            </div>
                          </div>
                        );
                      })
                    ) }
                    <React.Fragment>
                      {/* if patient is in a relation and slots are also available or if patient is in a relation and no slots are available */}
                          {user && filtered_slots && (user.has_relation && !filtered_slots.length) || (!user.has_relation && !filtered_slots.length) ?  (
                        <React.Fragment>
                          <div className="time_slots_text my-2">
                            {constants.CLICK_ON_ARRANGE_SESSION_TEXT}
                          </div>
                        </React.Fragment>
                      ) : null}

                      {/* if patient is in a relation and slots are also available or if patient is not in a relation and slots are available */}
                          {user && filtered_slots && (user.has_relation && filtered_slots.length) || (!user.has_relation && filtered_slots.length) ?  (
                        <React.Fragment>
                          <div className="time_slots_text my-2">
                            {constants.CLICK_ON_ARRANGE_SESSION_DIFFERENT_DATE}
                          </div>
                        </React.Fragment>
                      ) : null}

                      {/* Always show the Arrange session button */}
                      {user && (
                        <React.Fragment>
                          <button
                            onClick={this.arrangeSession}
                            id="btnCancelCreateAppointment"
                            className="btn btn-primary arrange-session-button align-center m-2">
                            {constants.ARRANGE_A_SESSION_BTN_TEXT}
                          </button>
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  </div>
                </div>
                <div className="mt-1 text-center">
                  {
                    this.props.session_cap && this.props.session_cap.project.is_session_cap_allowed ? (
                      <div className="d-flex flex-column align-items-center">
                        <span className="mb-1">
                          {`${constants.MAXIMUM_ALLOWED_SESSIONS_TXT} ${this.props.session_cap.total_session_cap}`}
                        </span>
                        <span>
                          {`${constants.TOTAL_REMAINING_TXT} ${getSessionsRemaining(this.props.session_cap.total_session_cap, this.props.session_cap.consumed_session_cap)}`}
                        </span>
                      </div>
                    ) : constants.NO_SESSION_CAP_TXT
                  }
                </div>
              </div>
            </div>
          </div>

          {this.state.selected_date_time !== "" && (
            <div>
              <div className="text-center mt-3">
                {constants.YOUR_CHOOSEN_TIME_TXT}{" "}
                {moment(this.state.selected_date_time).format("LLLL")}
              </div>
            </div>
          )}
          <div className="appoint-buttons pt-3 text-center">
            <button
              onClick={this.cancelAppointment}
              id="btnCancelCreateAppointment"
              className="btn time-slot-button-cancel time-slot-button m-1 mb-0 cancel-btn-create-appoitment"
            >
              {constants.CANCEL_TXT}
            </button>
            <button
              onClick={this.createAppointment}
              id="btnCreateAppointment"
              className="btn btn-primary time-slot-button m-1  mb-0"
              disabled={
                this.state.paypalModalVisible || this.state.foreeModalVisible
              }
            >
              {constants.SUBMIT_TXT}
            </button>
          </div>
        </div>
        {this.state.paypalModalVisible ? (
          <PaypalModal
            callAppointmentApiCall={this.callAppointmentApiCall}
            showPaypalModal={this.showPaypalModal}
            setIsLoading={this.setIsLoading}
            counsellorDetails={this.props.counsellorDetails}
            selected_date_time={this.state.selected_date_time}
          />
        ) : null}

        {this.state.foreeModalVisible ? (
          <ForeeModal
            callAppointmentApiCall={this.callAppointmentApiCall}
            showForeeModal={this.showForeeModal}
            setIsLoading={this.setIsLoading}
            counsellorDetails={this.props.counsellorDetails}
            selected_date_time={this.state.selected_date_time}
            cryptedString={this.state.cryptedString}
            errorPopup={this.errorPopup}
            contactNumber={this.props.user.contact_number}
          />
        ) : null}

        {this.props.isLoading || this.state.isLoading ? <Loading /> : null}
        {this.state.showRequestModal ? (
          <RequestSession
            dateTimes={this.state.dateTimes}
            whitelabel={this.state.subDomain}
            addSchedule={this.addSchedule}
            onCloseModal={this.toggleRequestModal}
            onCloseModalB2C={this.toggleRequestModalB2C}
            onDateChange={this.onDateChange}
            onTimeChange={this.onTimeChange}
            submitRequest={this.submitSessionRequest}
          />
        ) : null}
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {appointments} = state
  const _whitelabel = state.whitelabel.whitelabel ? state.whitelabel.whitelabel[0].sub_domain : '';
  if(_whitelabel === 'online'){
    return {
      user: state.auth.user,
      users: state.users,
      // isLoading: state.appointments.loading,
      item: state.item,
      slotsRequest:state.slots.slotsRequest,
      all_slots: state.slots.items,
      whitelabel: state.whitelabel.whitelabel,
      counsellorDetails: state.counsellorStatus.counsellorDetails,
      session_cap: appointments.session_cap_detail
    };
  }
  else if(_whitelabel !== 'online'){
    return {
      user: state.auth.user,
      users: state.users,
      isLoading: state.appointments.loading,
      item: state.item,
      all_slots: state.slots.items,
      slotsRequest:state.slots.slotsRequest,
      whitelabel: state.whitelabel.whitelabel,
      session_cap: appointments.session_cap_detail,
      counsellorDetails: state.counsellorStatus.counsellorDetails,
    };
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchTimeSlots: (counsellor_id) => {
      dispatch(slotActions.fetchTimeSlots(counsellor_id));
    },
    createAppointment: (appointmentDetails, counsellor_id) =>
      dispatch(
        appointmentActions.createAppointment(appointmentDetails, counsellor_id)
      ),
    getCounsellorDetails: (counsellorId) =>
      dispatch(counsellorActions.getCounsellorDetails(counsellorId)),
    resetSlots: () => dispatch(slotActions.resetSlots()),
    requestSlot: (schedules, counsellor_id) =>
      dispatch(appointmentActions.userRequestSession(schedules, counsellor_id)),
    requestSlotB2C: (counsellor_id) =>
      dispatch(appointmentActions.userRequestSessionB2C(counsellor_id)),
    arrangeSession: (counsellorId, projectId, role) =>
      dispatch(appointmentActions.patientArrangeAppointmentRequest(counsellorId, projectId, role)),
    getSessionCaps: ()=> {
      dispatch(appointmentActions.getSessionCaps())
    }
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DatePicker)
);



// WEBPACK FOOTER //
// ./src/screens/DatePicker/index.js